export default {
  title01: "موجودہ موسم",
  title02: "24 گھنٹے",
  title03: "10 دن کی موسم کی پیشن گوئی دیکھیں",
  title04: "AQI",
  title05: "تمام معلومات دیکھیں",
  title06: "سورج اور غروب آفتاب",
  title07: "چاند کا مرحلہ",
  title08: "اگلا پورا چاند",
  title09: "اگلا نیا چاند",
  title10: "دن",
  title11: "رات",
  title12: "سورج",
  title13: "غروب آفتاب",
  title14: "چاند طلوع",
  title15: "چاند ڈھلنا",
  title16: "ماخذ",
  title17: "شروع کریں",
  title18: "ختم",
  title19: "موجودہ مقام استعمال کریں",
  title20: "شہر کی تلاش کریں",
  title21: "ایسا محسوس ہوتا ہے",
  title22: "سایہ کی طرح محسوس ہوتا ہے",
  title23: "اب",
  title24: "آج",
  title25: "اتوار",
  title26: "پیر",
  title27: "منگل",
  title28: "بدھ",
  title29: "جمعرات",
  title30: "جمعہ",
  title31: "ہفتہ",
  title32: "لوڈ ہو رہا ہے...",
  title33: "اب",
  title34: "فی گھنٹہ",
  title35: "روزانہ",
  title36: "سورج اور چاند",
  title37: "ہوا کا معیار",
  title38: "پر رابطہ کریں: xlf550402@gmail.com",
  title39: "رازداری کا معاہدہ",
  title40: "کاپی رائٹ © comfortweather.com 2020 - 2026۔ تمام حق محفوظ ہیں۔",
  title41: "",
  title42: "اعلی درجہ حرارت",
  title43: "کم درجہ حرارت",
  title44: "قبول کریں",
  title45:
    'ComfortWeather  کا استعمال کرنے کے لئے شکریہ! آپ کے قانون حقوق اور منافع کو اچھی حفاظت کرنے کے لئے  آپ استعمال سے پہلے "خصوصی پولیسی" کو اچھی طرح پڑھ لیں. ',
  Title46: "حفاظتی پالیسی",
  title47: " استعمال سے پہلےاحتیاط",
  title48: "کے ذریعہ فراہم کردہ ڈیٹا",
  title49: "پر رابطہ کریں: xyjph123@gmail.com",
  title50: "کاپی رائٹ © 24hweather.com 2020 - 2026۔ تمام حق محفوظ ہیں۔",
  title51:
    '24hweather  کا استعمال کرنے کے لئے شکریہ! آپ کے قانون حقوق اور منافع کو اچھی حفاظت کرنے کے لئے  آپ استعمال سے پہلے "خصوصی پولیسی" کو اچھی طرح پڑھ لیں. ',
  title52: "آپ کی جگہ بدل گئ ہے، کیا آپ اپڈیٹ کرنہ چاہتے ہیں؟",
  title53: "ہاں",
  title54: "نہیں",
  title55: "پیچھے",
  title56: "خبریں",
  title57: " موسم کی ترمیم ہو چکی",
  title58: " موسم کی ترمیم",
  title59: "سب دیکھیں",
  title60: "کاپی رائٹ © mobi321.com 2020 - 2026۔ تمام حق محفوظ ہیں۔",
  title61: "گزشتہ کل",
  title62: "کل",
  title63: "15 دن کی موسم کی پیشن گوئی دیکھیں",
  title64: "آج کی تفصیلات",
  title65: "Rahu Kaal",
  title66: "طرز زندگی کا انڈیکس",
  title67: "طرز زندگی کا انڈیکس",
  title68: "未来7天Rahu Kala时间表",
  title69: "至",
  title70: "至",
  title71: "空气质量指数",

  title102: "خشک کرنا مشکل",
  title103: "آہستہ خشک ہونا",
  title104: "اچھی طرح خشک ہوجاتا ہے۔",
  title105: "جلدی خشک ہونا",
  title106: "بہت تیزی سے خشک ہونا",

  title107: "مناسب نہیں",
  title108: "معمولی تجربہ",
  title109: "پانی کے مزے کے لیے اچھا ہے",
  title110: "بہت موزوں",
  title111: "مثالی حالات",

  title112: "صحت کے لیے معاون",
  title113: "غیر جانبدار حالات",
  title114: "قدرے زیادہ خطرہ",
  title115: "زیادہ خطرہ",
  title116: "انتہائی خطرے میں",

  title117: "مناسب نہیں۔",
  title118: "کسی حد تک موزوں",
  title119: "باہر کے لیے اچھا ہے۔",
  title120: "بہت موزوں",
  title121: "بہترین حالات",

  title122: "انتہائی خشک حالات",
  title123: "ممکنہ طور پر خشک",
  title124: "ہلکی سی خشکی",
  title125: "خشکی کا امکان نہیں",
  title126: "خشکی کا بہت کم امکان",

  title127: "تجویز نہیں کی جاتی",
  title128: "قابل قبول",
  title129: "اچھا دن",
  title130: "بہت اچھے حالات",
  title131: "مثالی حالات",
};
